module.exports = __webpack_public_path__ + "img/food_hamburger.eddf72f3.png";